export default __webpack_public_path__ + "static/media/lock.a456ba96.svg";